import { defaultTheme } from '../../../theming/data/defaultTheme'
import fonts from '../../../tokens/fonts'
import layout from '../../../tokens/v2/layout'
import styled from 'styled-components'
import typography from '../../../tokens/v2/typography'
import { composeTheme } from '../../../utils/compose-theme'

export const Toggler = styled.div.attrs((props) => composeTheme(props))`
  border-top: ${(props) => props.theme.sideMenuAlt.borderWidth} solid
    ${(props) => props.theme.sideMenuAlt.borderColor};
  padding: ${layout.spacing.xmc} ${layout.spacing.xxxs};
  background-color: ${(props) => props.theme.sideMenuAlt.background};
`

export const Container = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  display: flex;
  cursor: pointer;
  padding: ${layout.spacing.xmc} ${layout.spacing.micro};
  justify-content: ${(props) => (props.theme.collapsed ? 'center' : 'left')};

  &:hover {
    color: ${(props) => props.theme.sideMenuAlt.activeColor};
    border-radius: ${(props) => props.theme.sideMenuAlt.activeBorderRadius};
    background-color: ${(props) => props.theme.sideMenuAlt.activeBackground};
    transition: color 0.25s;

    svg {
      fill: ${(props) => props.theme.sideMenuAlt.activeColor};
    }
  }
`
export const Icon = styled.div.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.sideMenuAlt.iconColor};

  &.keyboard-left {
    transform: rotate(180deg);
  }
`
export const Text = styled.div.attrs((props) => composeTheme(props))`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'block')};
  text-align: left;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.sideMenuAlt.fontSize};
  font-weight: ${(props) => props.theme.sideMenuAlt.fontWeight};
  line-height: ${typography.fontHeight.medium};
  color: ${(props) => props.theme.sideMenuAlt.color};
  padding-left: ${layout.spacing.micro};

  &:hover {
    color: ${(props) => props.theme.sideMenuAlt.activeColor};
  }
`

Toggler.defaultProps = defaultTheme
Container.defaultProps = defaultTheme
Icon.defaultProps = defaultTheme
Text.defaultProps = defaultTheme
